<template>
    <b-card>
        <b-card-header>
            <div>
                <b-row class="customer-search">
                    <b-col md="6" cols="12" class="search-field activity-schedule">
                        <customer-type-ahead v-model="filters.customer_id" />
                    </b-col>
                    <b-col md="6" cols="12" class="search-field">
                        <div class="input-group">
                            <input type="text" class="form-control" id="search-activity-schedule" v-model="query"
                                :placeholder="$translate('search_activity')">
                            <div class="input-group-prepend bg-transparent">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mt-2">
                        <b-button id="should-show-filter" variant="blue-button" class="me-2" size="sm"
                            @click="shouldShowFilters = !shouldShowFilters">
                            <span style="white-space: nowrap">
                                {{ $translate('filters') }}
                                <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                    }`"></b-icon>
                            </span>
                        </b-button>
                        <b-button id="activity-listing-button" variant="blue-button" class="me-2" size="sm"
                            @click="activityList">
                            <span style="white-space: nowrap">
                                {{ $translate('view_list') }}
                            </span>
                        </b-button>
                        <b-button id="reset-activity-filter-button" variant="blue-button" size="sm" @click="resetFilters" v-b-tooltip.hover
                            :title="$translate('reset_filters')">
                            <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                        </b-button>
                    </b-col>
                </b-row>
                <schedule-query-builder v-show="shouldShowFilters" v-model="filters" :orderTypes="orderTypes" :user="user"
                    :officers="officers" :roles="roles" />
            </div>
        </b-card-header>

        <b-overlay :show="!loaded" rounded="sm" class="mt-0 p-3">
            <div class="mt-2">
                <div class="font-weight-bold">
                    {{ selectedMonthEventsText }}
                </div>
                <FullCalendar :options="calendarOptions" :loaded="loaded" ref="calendar" @Click="handleDateClick"
                    class="full-calendar w-100 h-100" />
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import _ from 'lodash'
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'
import FullCalendar from '@fullcalendar/vue'
import ScheduleQueryBuilder from './ScheduleQueryBuilder.vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import esLocale from "@fullcalendar/core/locales/es";

export default {
    components: {
        FullCalendar,
        ScheduleQueryBuilder,
        CustomerTypeAhead,
    },
    data() {
        return {
            query: '',
            loaded: true,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    listPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                ],
                headerToolbar: {
                    left: '',
                    center: 'prev today next',
                    right: 'dayGridMonth dayGridWeek dayGridDay listDay',
                },
                buttonText: {
                    today: 'This Month',
                },
                datesSet: this.updateCustomButton,
                initialView: 'dayGridMonth',
                events: [],
                eventContent: this.renderEventContent,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                locale: this.getLocale(localStorage.getItem("language")) || "en"
            },
            filters: {
                customer_id: null,
                type_id: null,
                driver_id: null,
                role_id: null,
                due_from: null,
                due_to: null,
            },
            selectedMonthEventsText: '',
            shouldShowFilters: false,
        }
    },
    computed: {
        orders() {
            return this.$store.state.orders.items
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        roles() {
            return this.$store.state.roles.items
        },
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        user() {
            const _user = this.$store.state.user
            return _user
        },

    },

    mounted() {
        this.$set(this.filters, 'driver_id', parseInt(this.user.id))
        const calendarApi = this.$refs.calendar.getApi()
        calendarApi.on('eventClick', this.handleEventClick)
        calendarApi.on('dateClick', this.handleDateClick)
    },
    watch: {
        filters: {
            handler: function () {
                this.doSearch()
            },
            deep: true,
        },
        orders: {
            handler: function (val) {
                if (val) this.loaded = true
            },
            deep: true,
        },
        query: function () {
            this.doSearch()
        },
    },
    async created() {
        await this.$store.dispatch('checkoffTypes/fetchAll')
        await this.$store.dispatch('roles/fetchAll')
        await this.$store.dispatch('orderType/fetchAll')
        await this.$store.dispatch('users/fetchAll')
    },
    methods: {
        getLocale(language) {
            if (language == 'es') {
                return esLocale
            }
        },
        handleDateClick(info) {
            this.$store.commit('orders/updateScheduleDate', info.dateStr)
            this.$router.push(`/ams/activities/0`)
        },
        resetFilters() {
            this.filters = {
                customer_id: null,
                type_id: null,
                driver_id: null,
                role_id: null,
                due_from: null,
                due_to: null,
            }
            this.doSearch()
        },
        activityList() {
            this.$router.push("/ams/activities");
        },

        handleEventClick(eventClickInfo) {
            const eventId = eventClickInfo.event.id
            this.$router.push(`/ams/activities/${eventId}`)
        },
        doSearch: _.debounce(async function () {
            await this.updateCustomButton()
        }),

        scheduleData() {
            if (this.orders && Array.isArray(this.orders)) {
                console.log("this.orders", this.orders)
                const events = this.orders.map(item => ({
                    id: item.id,
                    start: item.schedule_date,
                    reference_no: item.reference_no,
                    customer_name: item && item.customer && item.customer.name,
                    officer_name: item && item.driver && item.driver.first_name + '' + item.driver.last_name,
                    activity_type: item && item.type && item.type.name,
                    due_date: item && item.schedule_date,
                }))
                this.calendarOptions.events = events
            }
        },
        renderEventContent(eventInfo) {
            const currentDate = new Date()
            const afterSevenDays = new Date()
            afterSevenDays.setDate(currentDate.getDate() + 7)
            const customer_name = eventInfo.event.extendedProps.customer_name || ''
            const officer_name = eventInfo.event.extendedProps.officer_name || ''
            const reference_no = eventInfo.event.extendedProps.reference_no
            const activity_type = eventInfo.event.extendedProps.activity_type
            const due_date = eventInfo.event.extendedProps.due_date
            const DueDate = new Date(due_date)
            let eventColor
            if (DueDate < currentDate) {
                eventColor = 'red'
            } else if (DueDate <= afterSevenDays) {
                eventColor = '#E49B0F'
            } else {
                eventColor = 'green'
            }
            const htmlContent = `
              <div  style="background-color: ${eventColor}; color:white;">
              <div> ${this.$translate('reference_no')}: ${reference_no}</div>
              <div> ${this.$translate('customer_name')}: ${customer_name}</div>
              <div> ${this.$translate('officer_name')}: ${officer_name}</div>
              <div> ${this.$translate('activity_type')}: ${activity_type}</div>
              <div> ${this.$translate('due_date')}: ${due_date}</div>
          </div>
        `

            return { html: htmlContent }
        },

        async updateCustomButton() {
            const calendarApi = this.$refs.calendar && this.$refs.calendar.getApi();
            if (!calendarApi) return
            const startOfMonth = moment.utc(calendarApi.currentData.dateProfile.currentRange.start);
            const endDate = moment.utc(calendarApi.currentData.dateProfile.currentRange.end);

            await this.pureSearch(startOfMonth, endDate);
            const title = calendarApi.currentData.viewSpec.buttonTextDefault
            const selectedMonthDateTitle = calendarApi.currentData.viewTitle

            const selectedMonthEventsCount = calendarApi.getEvents().length;
            this.calendarOptions.buttonText.today = this.getLabel(title)
            this.selectedMonthEventsText = `${selectedMonthDateTitle} ${this.$translate('showing')} ${selectedMonthEventsCount} ${this.$translate('events')}`
        },
        getLabel(title) {
            const lowerTitle = title && title.toLowerCase()
            switch (lowerTitle) {
                case this.$translate('month').toLowerCase():
                    return this.$translate('this_month')
                case this.$translate('week').toLowerCase():
                    return this.$translate('this_week')
                case this.$translate('day').toLowerCase():
                    return this.$translate('today')
                case this.$translate('list').toLowerCase():
                    return this.$translate('today')
                default:
                    return this.$translate('this_month')
            }
        },
        async pureSearch(startDate, endDate) {
            const formatteStartdDate = startDate.toISOString().substr(0, 10)
            const newDate = new Date(endDate);
            newDate.setDate(newDate.getDate() - 1);
            const formattedEndDate = newDate.toISOString().substr(0, 10)
            try {
                this.loaded = false
                const { query, filters } = this

                filters.due_from = formatteStartdDate
                filters.due_to = formattedEndDate
                await this.$store
                    .dispatch('orders/fetchSchedule', {
                        query,
                        filters,
                    })
                this.scheduleData()
            } catch (err) {
                console.error('loading error', err)
            }
        },
    },
}
</script>
